<template>
  <div class="app-container shopType">
    <div class="typeHeader">
      <el-button size="small" type="primary" @click="onAdd">新增</el-button>
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入类目"
        style="margin: 0px 10px;width: 200px;"
        :clearable="true"
      ></el-input>
      <el-select
        placeholder="全部一级类目"
        v-model="listQuery.parent_parent_id"
        :clearable="true"
        @change="getCategoryList(listQuery.type,2)"
        @clear="firstClose"
      >
        <el-option v-for="item in firstList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        placeholder="全部二级类目"
        :clearable="true"
        v-if="listQuery.parent_parent_id"
        v-model="listQuery.parent_id"
        style="margin-left:10px"
      >
        <el-option v-for="item in secondList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="listQuery.status" placeholder="上下架" :clearable="true" style="margin-left:10px"> 
        <el-option label="上架中" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <!-- <el-select
        v-model="listQuery.is_hot"
        placeholder="是否爆品"
        :clearable="true"
      >
        <el-option v-for="item in hotList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>-->
      <el-button size="small" type="primary" @click="handleSearch" style="margin-left: 10px;">搜索</el-button>
    </div>

    <el-table
      :data="list"
      :loading="listLoading"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column align="center" label="名称" min-width="110">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column align="center" label="级别" min-width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.level == 1">一级类目</el-tag>
          <el-tag type="primary" v-else-if="scope.row.level == 2">二级类目</el-tag>
          <el-tag type="warning" v-else>三级类目</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="上级类目" min-width="110">
        <template slot-scope="scope">
          <div>{{ scope.row.parent ? scope.row.parent.name : '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标" min-width="150">
        <template slot-scope="scope">
          <img
            v-if="scope.row.icon_url && scope.row.level == 3"
            :src="scope.row.icon_url"
            alt
            style="width: 110px"
          />
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="权重" min-width="95">
        <template slot-scope="scope">{{ scope.row.weight }}</template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 2" style="color:red;">已下架</span>
          <span v-else>上架中</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="small" @click="onEdit(scope.row)">修改</el-button>
          <el-button
            size="small"
            :type="scope.row.status == 2 ? 'primary' : 'warning'"
            @click="handleUpShelf(scope.row)"
          >{{ scope.row.status == 2 ? "上架" : "下架" }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="名称">
          <el-input
            v-model="form.name"
            style="width: 200px;"
            :clearable="true"
            placeholder="请输入类目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="级别">
          <el-select
            v-model="form.level"
            placeholder="类目级别"
            :clearable="true"
            @change="getFatherCategoryList()"
          >
            <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级目录" v-if="form.level == 2">
          <el-select
            v-model="form.parent_id"
            placeholder="请选择"
            clearable
            style="width: 120px;margin-right:10px"
          >
            <el-option
              v-for="item in fatherList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级目录" v-if="form.level == 3">
          <el-select
            v-model="first_id"
            placeholder="请选择"
            clearable
            style="width: 120px;margin-right:10px"
            @change="getFatherCategoryList()"
          >
            <el-option
              v-for="item in fatherList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级目录" v-if="first_id">
          <el-select
            v-model="form.parent_id"
            placeholder="请选择"
            clearable
            style="width: 120px;margin-right:10px"
          >
            <el-option
              v-for="item in secondList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权重">
          <el-input
            v-model="form.weight"
            style="width: 200px;"
            :clearable="true"
            placeholder="请输入权重"
          ></el-input>
        </el-form-item>
        <el-form-item label="图标" style="margin-bottom:20px;" v-if="form.level == 3">
          <UploadOne v-model="form.icon_url"></UploadOne>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button size="small" @click="handleCancel">返回</el-button>
          <el-button size="small" @click="handleSubmit" type="primary" :loading="btnLoading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
import { getQiniuToken } from "@/api/common";
import { guid } from "@/utils/index";
export default {
  components: {
    UploadOne
  },
  data() {
    return {
      listLoading: true,
      total: null,
       firstList: [],
      secondList: [],
      listQuery: {
        page: 1,
        limit: 10,
        keyword: "",
        level: "",
        status: "",
        type: 1,
        parent_parent_id:null,
        parent_id:null
      },
      first_id: "",
      form: {
        id: "",
        name: "",
        level: "",
        parent_id: 0,
        icon_url: "",
        weight: "",
        type: 2
      },
      showDialog: false,
      btnLoading: false,
      title: "", // dialog显示的标题
      list: [],
      fatherList: [],
      secondList: [],
      hotList: [
        { id: 0, name: "非爆品" },
        { id: 1, name: "爆品" }
      ],
      levelList: [
        { id: 1, name: "一级" },
        { id: 2, name: "二级" },
        { id: 3, name: "三级" }
      ]
    };
  },
  mounted() {
    if (this.$route.name == "Destination") {
      this.listQuery.type = 2;
      this.form.type = 2;
    } 
    this.getCategoryList(this.listQuery.type,1);
    this.getList();
    this.getFirstCate();
  },
  watch: {
    $route(to, from) {
      if (to.name == "Destination") {
        this.listQuery.type = 2;
        this.form.type = 2;
      } else {
        this.listQuery.type = 1;
        this.form.type = 1;
      }
      this.listQuery.parent_parent_id=null;
       this.listQuery. parent_id=null;
      this.getCategoryList(this.listQuery.type,1);
      this.getList();
    }
  },
  methods: {
    onAdd() {
      this.title = "新增类型";
      this.btnLoading = false;
      this.first_id="";
       this.fatherList= [];
      this.secondList=[];
      this.resetData();
      this.showDialog = true;
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/productCategory",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    getFirstCate() {
      request({
        url: "/api/backend/productCategory",
        method: "get",
        params: { level: 1, page: 1, limit: 9999, type: this.listQuery.type }
      }).then(response => {
        this.fatherList = response.data.data;
      });
    },
    getFatherCategoryList(type) {
      if (this.form.level == 1) {
        this.first_id = "";
        this.form.parent_id = 0;
        return;
      }
      if (!type) {
        this.form.parent_id = "";
      }
      if (this.first_id) {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: {
            parent_id: this.first_id,
            page: 1,
            limit: 9999,
            type: this.listQuery.type
          }
        }).then(response => {
          this.secondList = response.data.data;
        });
        return;
      }
      this.first_id = "";
      this.form.parent_id = "";
      request({
        url: "/api/backend/productCategory",
        method: "get",
        params: { level: 1, page: 1, limit: 9999, type: this.listQuery.type }
      }).then(response => {
        this.fatherList = response.data.data;
      });
    },
    onEdit(row) {
      this.title = "修改";
      this.btnLoading = false;
      this.form = Object.assign({}, row);
      if (this.form.level == 3) {
        this.first_id = row.parent.parent_id;
        this.getFatherCategoryList("noChange");
      } else if (this.form.level == 2) {
        this.first_id = "";
        this.getFatherCategoryList("noChange");
      }
      this.showDialog = true;
    },
    resetData() {
      this.form = {
        id: "",
        name: "",
        level: "",
        parent_id: 0,
        parent_parent_id: 0,
        icon_url: "",
        weight: "",
        type: this.listQuery.type
      };
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleSubmit() {

      if (!this.form.name) {
        this.$message({
          type: "error",
          message: "请填写名称!"
        });
        return;
      } else if (!this.form.level) {
        this.$message({
          type: "error",
          message: "请输入级别!"
        });
        return;
      } else if (this.form.level != 1 && !this.form.parent_id) {
        this.$message({
          type: "error",
          message: "请选择上级目录!"
        });
        return;
      } else if (this.form.level == 3 && !this.form.icon_url) {
        this.$message({
          type: "error",
          message: "请上传图标!"
        });
        return;
      } else if (this.form.weight < 0) {
        this.$message({
          type: "error",
          message: "权重不能小于0!"
        });
        return;
      }
      if (this.form.level == 3) {
        this.form.parent_parent_id = this.first_id;
      }
      this.btnLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(result => {
          request({
            url: "/api/backend/productCategory",
            method: "post",
            data: this.form
          })
            .then(result => {
              this.$notify.success("操作成功");
              this.getList();
               
              this.showDialog = false;
            })
            .catch(err => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
             this.btnLoading = false;
            });
        })
        .catch(err => {
          this.btnLoading = false;
          this.$notify.info("已取消");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleUpShelf(row) {
      let self = this;
      let state = row.status == 2 ? "上架" : "下架";
      self
        .$confirm(`此操作将会${state}该商品类型，是否继续`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(result => {
          request({
            url: "/api/backend/productCategory/upDown",
            method: "post",
            data: {
              id: row.id
            }
          })
            .then(result => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch(err => {
              this.$notify.error("操作失败");
            });
        })
        .catch(err => {
          this.$notify.info("已取消");
        });
    },
    handleSetHot(row) {
      this.$confirm("此操作将会修改爆品，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(result => {
          let rows = Object.assign({}, row);
          if (rows.is_hot) {
            rows.is_hot = 0;
          } else {
            rows.is_hot = 1;
          }
          request({
            url: "/api/backend/productCategory",
            method: "post",
            data: rows
          })
            .then(result => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch(err => {
              this.$notify.error("操作失败");
            })
            .finally(() => {});
        })
        .catch(err => {
          this.$notify.info("已取消");
        });
    },
    getCategoryList(type,  level,all=true) {
      var parent_id;
      if (level == 2) {
        if (type == 1) {
          if(all){
          this.listQuery.parent_id = "";
        }
          // parent_id = this.form.product_category[index].parent_parent_id;
        }
        //  else {
        //   if(all){
          // this.form.second_destination = "";
          // this.form.third_destination = "";}
          // parent_id = this.form.first_destination;
        // }
      } 
      // else if (level == 3) {
      //   type == 1
      //     ? (parent_id = this.form.product_category[index].parent_id)
      //     : (parent_id = this.form.second_destination);
      // }
      if (level != 1) {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: {
            level: level,
            page: 1,
            limit: 9999,
            type: type,
            parent_id: this.listQuery.parent_parent_id
          }
        }).then(response => {
          if (level == 2) {
           this.secondList = response.data.data;
          } 
          // else if (level == 3) {
          //   type == 1
          //     ? (this.thirdList = response.data.data)
          //     : (this.thirdDestinationList = response.data.data);
          // }
        });
      } else {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: { level: level, page: 1, limit: 9999, type: type }
        }).then(response => {
          this.firstList = response.data.data
           ;
        });
      }},
    firstClose(){
      this.listQuery.parent_id = null
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;

  line-height: 178px;
  text-align: center;
}
</style>
